import * as React from 'react';
import { formValueSelector, FormSection, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import { Divider } from 'material-ui';

import {
  Toggle,
  ToggleTwoLabels,
  InlineGridField,
  InlineGrid,
  AutoCompleteField,
  AutoComplete
} from '@components/form';

import RemoteChipInput, { RemoteChipInputField } from '@components/form/RemoteChipInput/RemoteChipInput';
import { Person } from '@components/person';
import Address, { AddressField } from '@components/form/Address/Address';
import { eventsFormReportsGridColumns } from './_eventsColumns';
import { withNotifications } from '@components/hoc/withNotifications';
import { getAllStations } from '@modules/events/_eventsActions';
import { getAllShifts } from '@modules/hr-shifts/_shiftsActions';

const enhance = compose<any, any>(
  withNotifications({ getAllStations, getAllShifts }),
  connect(state => ({
    reports: formValueSelector('module-events')(state, 'reports'),
    person: formValueSelector('module-events')(state, 'person'),
    station: formValueSelector('module-events')(state, 'station'),
    shift: formValueSelector('module-events')(state, 'shift')
  })),
  lifecycle<any, {}, {}>({
    async componentDidMount() {
      const { getAllStationsNotify, getAllShiftsNotify } = this.props;
      let stations, shifts;
      try {
        stations = await getAllStationsNotify();
        shifts = await getAllShiftsNotify();
        this.setState({ stations, shifts: shifts.items });
      } catch {
        this.setState({ stations: [], shifts: [] });
      }
    }
  }),
  reduxForm({
    form: 'module-events'
  })
);

const View: React.SFC<any> = ({ change, person, form, disabled, stations, shifts }) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>
    <Row>
      <Col md={12}>
        <Row>
          <Col md={4} className="with-right-divider">
            <Row>
              <Col md={12}>
                <h4>Oznamovatel</h4>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <ToggleTwoLabels
                  component={Toggle}
                  name="person"
                  disabled={disabled}
                  onToggle={(_, value) => {
                    change('report.internalReporters', []);
                    change('report.externalReporter', null);
                    change('person', value);
                  }}
                  labelLeft="Strážník"
                  labelRight="Osoba"
                  onClickLeft={() => change('person', false)}
                  onClickRight={() => change('person', true)}
                />
              </Col>
            </Row>
          </Col>
          {person ? (
            <Col md={8}>
              <Row>
                <Col className="grid-system-margin" />
              </Row>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={12} className="with-right-divider">
                      <Row>
                        <Col md={12}>
                          <h4>Jméno</h4>
                        </Col>
                      </Row>
                      <FormSection name="report.externalReporter">
                        <Person form={form} disabled={disabled} formName="report.externalReporter." withPhone={true} />
                      </FormSection>
                      <AddressField component={Address} disabled={disabled} name={'report.externalReporter.address'} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col md={8}>
              <Row>
                <Col md={12}>
                  <h4>Strážníci</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RemoteChipInputField
                    component={RemoteChipInput}
                    id="internalReporters"
                    name="report.internalReporters"
                    url="/metropolis/api/hr/employees"
                    labelFunction={o => get(o, 'fullName')}
                    fullWidth={true}
                  />
                  <InlineGridField
                    component={InlineGrid}
                    name="report.internalReporters"
                    columns={eventsFormReportsGridColumns}
                    showCheckboxes={false}
                    adding={false}
                    deleting={false}
                    editing={false}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Divider />
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col md={12}>
            <h4>Zařazení události</h4>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AutoCompleteField
              component={AutoComplete}
              label="Pracoviště"
              name="station"
              items={stations ? stations.filter(v => v.active) : []}
              labelFunction={o => get(o, 'name')}
              valueFunction={o => o}
              fullWidth={true}
            />
          </Col>
          <Col md={6}>
            <AutoCompleteField
              component={AutoComplete}
              label="Směna"
              name="shift"
              items={shifts}
              labelFunction={o => get(o, 'name')}
              valueFunction={o => o}
              fullWidth={true}
            />
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Divider />
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col md={12}>
            <h4>Zúčastnění strážníci</h4>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RemoteChipInputField
              component={RemoteChipInput}
              id="officers"
              name="officers"
              url="/metropolis/api/hr/employees"
              labelFunction={o => get(o, 'fullName')}
              fullWidth={true}
            />
            <InlineGridField
              component={InlineGrid}
              name="officers"
              columns={eventsFormReportsGridColumns}
              showCheckboxes={true}
              editing={false}
              adding={false}
              deleting={false}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </Grid>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormReports.tsx